import { addRadarTags, removeRadarTags } from '../set-radar-tags';

// ─── Helpers ────────────────────────────────────────────────────────────────

export function setRadarMarketingPushSubscribed(isSubscribed: boolean): void {
  if (isSubscribed) {
    addRadarTags(['marketing_push_subscribed']);
    return;
  }

  removeRadarTags(['marketing_push_subscribed']);
}
